<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 17:07:18
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-15 17:36:07
 * @FilePath: \crm-product\found\views\cps\views\rights\fee\dealer_no_invoice_fee\form\form.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  name: 'modules',
  extends: TablePage,
  components: {},
  props: {
    participatorCode: String,
  },
  data() {
    return {
      requestType: 'GET',
      requestUrl: '/cps-mobile/consumerdynamicredpacket/queryDetailPage',
      params: {
        participatorCode: this.participatorCode,
      },
    };
  },
  async created() {
    await this.getConfigList('detail_list');
  },
  methods: {},
};
</script>
